export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/selected-star-icon.png?8bf913ccef025d6fcaeb1f735c592616";